import { Component, ElementRef, viewChild } from '@angular/core';

interface TeamMember {
  id: number;
  image: string;
  class?: string;
  link?: string;
  toolTip?:boolean
}

@Component({
  selector: 'app-teams',
  standalone: false,
  templateUrl: './teams.component.html',
  styleUrl: './teams.component.scss',
})
export class TeamsComponent {
  readonly slider = viewChild<ElementRef>('teamSlider');

  teamMembers: TeamMember[] = [
    { id: 1, image: '/assets/images/team/paul-jarvis.png', toolTip: true },
    { id: 2, image: '/assets/images/team/lucas-fiorito.png', toolTip: true },
    { id: 3, image: '/assets/images/team/aiden-cowen.jpg', class: "last-person", toolTip:true },
  ];

  scrollLeft(): void {
    this.slider()?.nativeElement.scrollBy({ left: -280, behavior: 'smooth' });
  }

  scrollRight(): void {
    this.slider()?.nativeElement.scrollBy({ left: 280, behavior: 'smooth' });
  }
}